'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = detectScale;

var _dom = require('../dom');

function detectScale() {
  var ratio = (0, _dom.getCharacterWidth)('👩' /* woman */) / (0, _dom.getCharacterWidth)('J!i');
  return Math.round(ratio * 10) / 10;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZXRlY3Qvc2NhbGUuanMiXSwibmFtZXMiOlsiZGV0ZWN0U2NhbGUiLCJyYXRpbyIsIk1hdGgiLCJyb3VuZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBRXdCQSxXOztBQUZ4Qjs7QUFFZSxTQUFTQSxXQUFULEdBQXVCO0FBQ3BDLE1BQU1DLFFBQVEsNEJBQWtCLElBQWxCLENBQXVCLFdBQXZCLElBQXNDLDRCQUFrQixLQUFsQixDQUFwRDtBQUNBLFNBQU9DLEtBQUtDLEtBQUwsQ0FBV0YsUUFBUSxFQUFuQixJQUF5QixFQUFoQztBQUNEIiwiZmlsZSI6InNjYWxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZ2V0Q2hhcmFjdGVyV2lkdGggfSBmcm9tICcuLi9kb20nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkZXRlY3RTY2FsZSgpIHtcbiAgY29uc3QgcmF0aW8gPSBnZXRDaGFyYWN0ZXJXaWR0aCgn8J+RqScgLyogd29tYW4gKi8pIC8gZ2V0Q2hhcmFjdGVyV2lkdGgoJ0ohaScpO1xuICByZXR1cm4gTWF0aC5yb3VuZChyYXRpbyAqIDEwKSAvIDEwO1xufVxuIl19